var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_831_13800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.79615 7.8753V3.87578C10.6517 4.02009 11.4585 4.37117 12.1482 4.89838C12.2857 4.99267 12.447 5.04382 12.614 5.04607C13.1492 5.04607 13.5855 4.61544 13.5912 4.08028C13.5923 3.85078 13.5025 3.63035 13.3412 3.46673C12.3447 2.61341 11.0949 2.11007 9.7848 2.03508V0.694314C9.7848 0.311389 9.47461 0.00120219 9.09169 0.00120219C9.08374 7.71813e-05 9.07576 7.71813e-05 9.06782 7.71813e-05C8.67923 -0.00561819 8.35881 0.304604 8.35312 0.694314V1.98962C5.7966 2.17142 4.05818 3.75079 4.05818 5.85281C4.05818 8.43204 6.2511 9.14789 8.35312 9.71599V14.2609C7.24414 14.1121 6.19883 13.6519 5.34209 12.9316C5.18076 12.8032 4.98076 12.7316 4.77396 12.727C4.25017 12.7634 3.84681 13.202 3.8536 13.7269C3.85247 13.9564 3.94223 14.1769 4.10356 14.3405C5.2773 15.3972 6.78622 16.0051 8.36444 16.0562V17.3061C8.36444 17.314 8.36556 17.322 8.36556 17.3299C8.38374 17.7185 8.71439 18.0185 9.10297 17.9992C9.4859 17.9992 9.79608 17.689 9.79608 17.3061V16.0335C12.898 15.829 14.1478 13.9428 14.1478 11.9431C14.1479 9.26152 11.8982 8.44343 9.79615 7.8753ZM8.36451 7.51171C7.12601 7.14812 6.16022 6.77317 6.16022 5.71647C6.16022 4.65977 7.03513 3.89849 8.36451 3.79625V7.51171ZM9.79615 14.2836V10.1478C11.0801 10.5114 12.08 10.9999 12.0686 12.193C12.0686 13.0565 11.4778 14.0791 9.79615 14.2836Z",
    fill: "#757575"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_831_13800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDollar);
export default __webpack_public_path__ + "static/media/ic-dollar.aa93111711df79c150a45c61b0ff095c.svg";
export { ForwardRef as ReactComponent };